import "./CandidateOfferResponse.css";
import { useParams } from "react-router-dom";
import Loginheader from "../../components/loginheader/Loginheader";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";

export default function CandidateOfferResponse() {
    const { cid } = useParams();
    const [offer_letter_remarks, setOfferRemarks] = useState("");
    const { backUrl } = useContext(AuthContext);

    const handleResponse = async (action) => {
        try {
            await axios.put(`${backUrl}/api/emp/offer-response/${cid}/`, {
                action: action,
                offer_letter_remarks: offer_letter_remarks
            });

            toast.success(`You have ${action === 'accept' ? 'accepted' : 'declined'} the offer.`);

            setTimeout(() => {
                window.close();
            }, 3000);
        } catch (error) {
            toast.error("Something went wrong. Please try again later.");
        }
    };

    return (
        <div className="full-page d-flex flex-column min-vh-100 bg-light">
            <Loginheader />
            <div className="container mt-5 mb-4 flex-grow-1">
                <div className="offer-response-container shadow-lg p-5 bg-white rounded">
                    <h2 className="text-center mb-4 text-primary fw-bold">Offer Letter Response</h2>
                    <p className="text-muted">
                        Thank you for taking the time to review the offer letter. We are excited about the possibility of having you join our team.
                    </p>
                    <p className="text-muted">
                        Please review the offer details that were sent to your registered email. Once you're ready, let us know your decision by selecting one of the options below.
                    </p>

                    <div className="mb-4">
                        <textarea
                            name="offer_letter_remarks"
                            value={offer_letter_remarks}
                            onChange={(e) => setOfferRemarks(e.target.value)}
                            placeholder="Add your message here..."
                            className="form-control"
                            rows={4}
                        />
                    </div>

                    <div className="response-buttons d-flex gap-3 justify-content-center mb-4">
                        <button
                            className="btn btn-success px-4"
                            onClick={() => handleResponse('accept')}
                        >
                            Accept Offer
                        </button>
                        <button
                            className="btn btn-outline-danger px-4"
                            onClick={() => handleResponse('decline')}
                        >
                            Decline Offer
                        </button>
                    </div>

                    <p className="note text-center text-secondary">
                        If you have any questions or concerns regarding the offer, feel free to contact our HR team before making your decision.
                    </p>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={3000} />
        </div>
    );
}
